import { BusinessList } from './../icustomer/icustomer-register/icustomer-register.component';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-employee-order-edit',
  templateUrl: './employee-order-edit.component.html',
  styleUrls: ['./employee-order-edit.component.scss']
})
export class EmployeeOrderEditComponent implements OnInit {

  input_field: any = null;
  product_list: any;
  input_value: any = null;
  business_list: any;
  search_term: any;
  filtered_business_list: any;
  employee_code: any;
  employee_order: any;

  constructor(public dialogRef: MatDialogRef<EmployeeOrderEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data, private http: HttpService) {
    console.log(data);
    this.input_field = data['input'];
    this.employee_code = data['employee_order']['employee_code'];
    this.employee_order = data['employee_order'];
    if (this.input_field == 'booth_code') {
      this.input_value = this.employee_order.booth_code;
    } else if (this.input_field == 'product') {
      this.input_value = this.employee_order.product;
    } else {
      this.input_value = this.employee_order.quantity;
    }

    this.http.getAllbusinessForBothChange().subscribe((data: []) => {
      console.log(data);
      this.business_list = data;
    }, (error) => {
      console.log(error);
    });

    this.getEmployeeProducts();

  }

  changeInputValue() {
    console.log(this.input_value)
    if (this.input_value == null) {
      if (this.input_field == 'booth_code') {
        this.input_value = this.employee_order.booth_code;
      } else if (this.input_field == 'product') {
        this.input_value = this.employee_order.product;
      } else {
        this.input_value = this.employee_order.quantity;
      }
    }
    console.log(this.input_field);
    let data_dict = {
      'value': this.input_value
    }
    console.log(data_dict);
    this.dialogRef.close(data_dict);

  }

  searchBusinessCalled(search_term) {
    console.log(search_term);
    if (this.search_term == null || this.search_term === '') {
      this.filtered_business_list = [];
    } else {
      this.filtered_business_list = this.business_list.filter((element) => {
        return element.name.toLowerCase().indexOf(search_term.toLowerCase()) > -1 || element.code.toLowerCase().indexOf(search_term.toLowerCase()) > -1;
      });
    }
  }

  selecBooth(booth_code) {
    this.input_value = booth_code;
  }

  getEmployeeProducts() {
    this.http.getEmployeeProducts().subscribe((data) => {
      console.log(data);
      this.product_list = data;
    }, (error) => {
      console.log(error);
    });
  }

  ngOnInit() {
  }

}
